import React from "react";
import { Text } from "@salestrak/ui";
import type { ActivityChange } from "../activity-types";
import { useOptionalActivityContext } from "../activity-context";

interface NoteChunkProps {
  change: ActivityChange;
}

export function NoteChunk({ change }: NoteChunkProps) {
  const ctx = useOptionalActivityContext();

  const handleViewComment = () => {
    const noteId = change.newValue?.value;
    if (noteId && ctx?.scrollToNote) {
      ctx.scrollToNote(noteId);
    }
  };

  // The link exists only where a timeline can scroll to the comment (the
  // issue view's activity tab). A feed with no scroll target — a dashboard
  // card whose row press opens the project — says the fact without a verb
  // that would do nothing.
  // A comment deleted since leaves its earlier rows ("edited a comment")
  // with nothing to scroll to, so they lose the link too.
  const noteId = change.newValue?.value;
  const canView =
    change.action !== "deleted" &&
    Boolean(ctx?.scrollToNote) &&
    !!noteId &&
    !!ctx?.getNote(noteId);
  return (
    <Text size="sm">
      {change.action} a comment
      {canView ? (
        <Text size="sm">
          {" "}
          {/* Inline pressable Text (a span) — never a Button, which is a flex
              box and would break out of this sentence onto its own line. */}
          <Text
            size="sm"
            variant="primary"
            className="cursor-pointer select-none"
            onClick={handleViewComment}
          >
            View comment
          </Text>
        </Text>
      ) : null}
    </Text>
  );
}
